import defaultTheme from 'components/alexandria-ui/theme/theme';

const getDefaultColors = (theme: any) =>
  Object.keys(theme).reduce((acc, key) => {
    if (key.includes('-')) {
      const [proposedKey, fallbackValue] = key.split('-');
      const actualKey = theme.hasOwnProperty(fallbackValue) ? proposedKey : key;
      return { ...acc, [actualKey]: theme[key] || theme[fallbackValue] };
    } else {
      return { ...acc, [key]: theme[key] };
    }
  }, defaultTheme);
const formatPrismicConfig = (config: any) => ({
  ...config,
  theme: getDefaultColors(config.theme),
});
export { formatPrismicConfig };
